import React from "react";
import doctor from "../../assets/images/doctor.jpg";
import treatment from "../../assets/images/urology-treatment.jpg";
import experience from "../../assets/images/experience.png";
import equipment from "../../assets/images/equipment.png";
import care from "../../assets/images/patient-care.png";

import "./AboutUrologist.css";

const AboutUrologist = () => {
  return (
    <section className="container py-5">

      {/* Doctor Profile */}

      <div className="row align-items-center">

        <div className="col-md-5 text-center mb-4">

          <div className="doctor-img-container">

            <img
              src={doctor}
              alt="Dr Abhinav Singh"
              className="doctor-img"
            />

          </div>

        </div>

        <div className="col-md-7">

          <h2 className="fw-bold mb-3">
            About Dr Abhinav Singh
          </h2>

          <h5 className="text-primary">
            Consultant Urologist (MS, MCh)
          </h5>

          <p className="text-muted mt-3">

            Dr Abhinav Singh is a highly experienced consultant urologist
            specializing in diagnosis and treatment of urinary tract
            diseases and male reproductive health.

          </p>

          <p className="text-muted">

            He provides advanced treatment for kidney stones,
            prostate disorders, urinary infections and male infertility
            using modern urology techniques.

          </p>

          <ul className="mt-3">

            <li>✔ Kidney Stone Treatment & Surgery</li>
            <li>✔ Prostate Disease Management</li>
            <li>✔ Male Infertility Treatment</li>
            <li>✔ Urinary Tract Infection Care</li>
            <li>✔ Minimally Invasive Urology Procedures</li>

          </ul>

        </div>

      </div>

      {/* Experience | Equipment | Patient Care */}

      <div className="row text-center mt-5">

        <div className="col-md-4 mb-4">

          <div className="feature-card p-4">

            <img
              src={experience}
              alt="Experience"
              className="feature-icon"
            />

            <h5 className="mt-3 fw-bold">
              Experience
            </h5>

            <p className="text-muted">
              Years of experience in treating complex
              urology conditions with modern techniques.
            </p>

          </div>

        </div>

        <div className="col-md-4 mb-4">

          <div className="feature-card p-4">

            <img
              src={equipment}
              alt="Modern Equipment"
              className="feature-icon"
            />

            <h5 className="mt-3 fw-bold">
              Modern Equipment
            </h5>

            <p className="text-muted">
              Advanced diagnostic and surgical equipment
              for safe and effective treatment.
            </p>

          </div>

        </div>

        <div className="col-md-4 mb-4">

          <div className="feature-card p-4">

            <img
              src={care}
              alt="Patient Care"
              className="feature-icon"
            />

            <h5 className="mt-3 fw-bold">
              Patient Care
            </h5>

            <p className="text-muted">
              Dedicated patient care with detailed consultation
              and personalized treatment plans.
            </p>

          </div>

        </div>

      </div>

      {/* Advanced Urology Care */}

      <div className="row mt-5 align-items-center">

        <div className="col-md-6">

          <h3 className="fw-bold">
            Advanced Urology Care
          </h3>

          <p className="text-muted">

            Our clinic provides comprehensive urology services
            including kidney stone removal, prostate treatment,
            urinary tract infection management and infertility care.

          </p>

        </div>

        <div className="col-md-6 text-center">

          <div className="treatment-img-container">

            <img
              src={treatment}
              alt="Urology Treatment"
              className="treatment-img"
            />

          </div>

        </div>

      </div>

    </section>
  );
};

export default AboutUrologist;